export default function WithSideDescription (Comp) {
  const CompWithDesc = ({ props, listeners, attrs, data }) =>
    <div class="d-flex align-items-center w-100">
      <div class="pr-2 flex-1">
        <Comp {...{ ...props, ...listeners, ...attrs, ...data }} description={''} />
      </div>
      <div class="pl-2 text-muted flex-1 mt-4">
        { props.description }
      </div>
    </div>

  return CompWithDesc
}
